import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=1cc55ab9&scoped=true&"
import script from "./LanguageMenu.vue?vue&type=script&lang=ts&"
export * from "./LanguageMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageMenu.vue?vue&type=style&index=0&id=1cc55ab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc55ab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemGroup,VListItemTitle,VMenu})
